import { Button, Typography } from '@mui/material'
import { WarningRounded } from '@mui/icons-material'
import { useSmartTranslation } from '../../../generic/hooks/useSmartTranslation'
import createDialogTitle from '../../../generic/utilities/dialogUtil'
import { SmartDialog } from '../../../generic/utilities/SmartDialog'

/**
 * Historia 161-serialize-concurrent-workflow-saves-to-stop-d (jupiter slice) — CU6, D3, RN19, RN20.
 *
 * Sun rejects a "save as new version" with HTTP 409 `WORKFLOW_VERSION_ALREADY_SAVED` when the
 * series already has an active version newer than the one this save started from (RN4, D2: a
 * double click, a stale retry, a duplicated tab or another user's save — the server does not
 * distinguish them, P1). Jupiter never shows that as a raw error (RN19): it opens this dialog with
 * two choices — Reload (opens the vigent version, discarding unsaved changes) or Stay in the
 * editor (keeps the edit exactly as it was, RN20). A new save from "Stay in the editor" will hit
 * the same conflict again and reopen this same dialog (CU6-A1).
 *
 * @param {Object} props
 * @param {boolean} props.open
 * @param {Function} props.onReload
 * @param {Function} props.onStay
 */
const WorkflowVersionConflictDialog = ({ open, onReload, onStay }) => {
  const { t_ } = useSmartTranslation()

  return (
    <SmartDialog
      setOpen={open}
      title={createDialogTitle({ title: t_('Workflow already saved'), icon: WarningRounded, color: 'warning' })}
      message={t_('WORKFLOW_VERSION_ALREADY_SAVED')}
      accept={false}
      cancel={false}
      close={false}
      renderCustomButtons={
        <>
          <Button color='primary' onClick={onStay} variant='outlined'>
            <Typography color='primary'>{t_('Stay in the editor')}</Typography>
          </Button>
          <Button color='primary' onClick={onReload} variant='outlined'>
            <Typography color='primary'>{t_('Reload')}</Typography>
          </Button>
        </>
      }
    />
  )
}

export default WorkflowVersionConflictDialog
